import React from "react";
import { ThunderboltOutlined, ShakeOutlined, WarningOutlined } from "@ant-design/icons";
import GameDetails from "./GameDetails";

const ItiGame: React.FC = () => (
    <GameDetails
        game="iti"
        tagColor="green"
        fallbackInstructionIcon={<WarningOutlined style={{ color: "#ff4d4f" }} />}
        instructionIcons={[
            <ThunderboltOutlined key="first" style={{ color: "#ffec3d" }} />,
            <ShakeOutlined key="second" style={{ color: "#faad14" }} />,
            <WarningOutlined key="third" style={{ color: "#ff4d4f" }} />,
        ]}
    />
);

export default ItiGame;
